// API文档相关API
import request from '@/api'

// 站内信获取usersig
export async function getImUsersig(userId) {
  return request({
    url: `/capi/mcgw/v1/push/im/usersig?expire=31536000&msgType=60&userId=${userId}`,
    method: 'post'
  })
}

// 获取站内信列表（全部/未读/已读）
export async function getLetterPage(data) {
  return request({
    url: `/capi/interletter/v1/letter/page`,
    method: 'post',
    data
  })
}

// 删除站内信
export async function letterDelete(data) {
  return request({
    url: `/capi/interletter/v1/letter/delete`,
    method: 'post',
    data
  })
}

// 标记已读/未读
export async function readLetter(data) {
  return request({
    url: `/capi/interletter/v1/letter/read_letter`,
    method: 'post',
    data
  })
}

